export default __webpack_public_path__ + "static/media/human4.cb23dbf9.png";